import React, { useEffect, useState } from "react";
import "./styles.scss";
import { useTranslation } from "react-i18next";
import FadeInSection from "../../../Components/FadeInSection";
import axios from "../../../api/axiosService";
import { useNavigate } from "react-router-dom";

// const jobList = [
//   {
//     title: "Account Intern",
//     id: 1,
//     location: "HCM",
//     highlight: true,
//     link: "/jobs/account-intern",
//   },
//   {
//     id: 2,
//     title: "Senior Planning Executive",
//     location: "HCM",
//     link: "/jobs/senior-planning",
//   },
//   {
//     id: 3,
//     title: "Intern Graphic Design",
//     location: "HCM",
//     link: "/jobs/intern-design",
//   },
//   {
//     id: 4,
//     title: "Senior Account Executive",
//     location: "HCM",
//     link: "/jobs/senior-account",
//   },
//   { id: 5, title: "Artist", location: "HCM", link: "/jobs/artist" },
//   {
//     id: 6,
//     title: "Marketing Executive",
//     location: "HCM",
//     link: "/jobs/marketing",
//   },
// ];

function Careers() {
  const { t } = useTranslation();
  const [keyword, setKeyword] = useState("");
  const [jobs, setJobs] = useState([]);
  const [jobList, setJobList] = useState([]);
  const navigate = useNavigate();

  const getCareeres = async () => {
    try {
      const response = await axios.get("/api/career/list");
      setJobs(response.data.data);
      setJobList(response.data.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    getCareeres();
  }, []);

  const getJobList = async (keyword = "") => {
    if (keyword)
      setJobs(
        jobList.filter((e) =>
          e.title.toLocaleLowerCase().includes(keyword.toLocaleLowerCase()),
        ),
      );
    else setJobs(jobList);
  };

  const handleSearch = (event) => {
    if (event.key === "Enter") {
      getJobList(keyword);
    }
  };

  useEffect(() => {
    getJobList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobList]);

  return (
    <div className="career-ssl min-h-screen px-4 font-sans">
      <div className="carreer-header global-header-block-2">
        <FadeInSection direction="down">
          <div className="news-text normal-text">{t("CREW")}</div>
          <h1 className="news-title global-title-margin title-1">
            {" "}
            {t("SSL_CARREER")}
          </h1>
        </FadeInSection>
      </div>

      <div className="relative w-full h-full md:h-[49px] max-w-[490px] px-[20px] md:px-0 mb-[50px] md:mb-[150px]">
        <FadeInSection delay={200}>
          <input
            id="search"
            type="text"
            placeholder="Search"
            className="search-bar w-full h-full md:w-[490px] md:h-[49px] max-w-[490px] max-h-[49px] border border-gray-300 rounded-none py-[15px] px-[20px] pr-12 focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            onKeyDown={handleSearch}
          />
          <div className="absolute inset-y-0 right-[0px] flex items-center pr-[20px] pointer-events-none">
            <svg
              className="w-[26px] h-[26px] text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.5 4.5a7.5 7.5 0 0012.15 12.15z"
              />
            </svg>
          </div>
        </FadeInSection>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 [@media(max-width:900px)]:gap-[20px] gap-[50px]  max-w-8xl md:px-20">
        {jobs.map((job, index) => (
          <span
            key={index}
            onClick={() => navigate(`/ssl-carreer/${job.id}`)}
            rel="noopener noreferrer"
            className="career-section aspect-square w-[80vw] md:w-full flex flex-col justify-between relative border transition hover:shadow-lg cursor-pointer"
          >
            <div className="career-header flex justify-between ">
              <FadeInSection key={index} delay={100 * (index % 2)}>
                <h3 className="career-title uppercase break-words whitespace-normal pb-[20px] title-2">
                  {job.title}
                </h3>
              </FadeInSection>
              <div className="career-icon mt-2">
                <svg
                  className="w-[32px] h-[32px] rotate-180"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M17.25 6.75H6.75M17.25 6.75v10.5M17.25 6.75L6.75 17.25"
                  />
                </svg>
              </div>
            </div>

            <p className="career-location normal-text">{job.shortLocation}</p>
          </span>
        ))}
      </div>
    </div>
  );
}

export default Careers;
